<template>
  <el-scrollbar
    wrap-style="height: calc(100% + 17px);"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div style="padding: 20px">
      <slot></slot>
    </div>
  </el-scrollbar>
</template>

<script>
export default {
  name: 'VMain',
  props: {
    loading: Boolean
  }
};
</script>

<style></style>
